(() => {
  const roots = new WeakSet();

  const selectedSize = (productInfo) => {
    const radios = [...productInfo.querySelectorAll('variant-selects input[type="radio"]:checked')];
    const sizeRadio = radios.find((input) => /size/i.test(input.dataset.optionName || input.name));
    if (sizeRadio) return sizeRadio.value;

    const selects = [...productInfo.querySelectorAll('variant-selects select')];
    const sizeSelect = selects.find((select) => /size/i.test(select.name));
    return sizeSelect?.value || '';
  };

  const currentPrice = (productInfo, sectionId) => {
    const priceRoot = productInfo.querySelector(`#price-${CSS.escape(sectionId)}`);
    if (!priceRoot) return '';
    const sale = priceRoot.querySelector('.price--on-sale .price-item--sale');
    const regular = priceRoot.querySelector('.price-item--regular');
    return (sale || regular)?.textContent.trim() || '';
  };

  const isSelectSizeLabel = (text) => /select\s+a\s+size/i.test((text || '').replace(/\s+/g, ' ').trim());

  const scrollToSizeSelector = (productInfo) => {
    const picker = productInfo.querySelector('[data-pdp-size-selector], variant-selects');
    if (!picker) return;

    picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(() => {
      const firstChoice = picker.querySelector('input:not([disabled]), select:not([disabled])');
      firstChoice?.focus({ preventScroll: true });
    }, 350);
  };

  const sync = (bar) => {
    const productInfo = bar.closest('product-info');
    if (!productInfo) return;

    const sectionId = bar.dataset.sectionId;
    const mainButton = productInfo.querySelector(`#ProductSubmitButton-${CSS.escape(sectionId)}`);
    const option = bar.querySelector('[data-sticky-option]');
    const price = bar.querySelector('[data-sticky-price]');
    const stickyButton = bar.querySelector('[data-sticky-submit]');
    const label = bar.querySelector('[data-sticky-label]');
    const size = selectedSize(productInfo);

    if (option) {
      option.hidden = !size;
      const optionText = size ? `Size ${size}` : '';
      if (option.textContent !== optionText) option.textContent = optionText;
    }

    const updatedPrice = currentPrice(productInfo, sectionId);
    if (price && updatedPrice && price.textContent !== updatedPrice) price.textContent = updatedPrice;

    if (mainButton && stickyButton) {
      const mainLabel = mainButton.querySelector('span')?.textContent.trim() || '';
      const selectingSize = isSelectSizeLabel(mainLabel);
      // "Select a Size" is an actionable prompt, not an unavailable state.
      // Keep it enabled so the CTA can take the shopper back to the picker.
      if (selectingSize) {
        if (mainButton.disabled) mainButton.disabled = false;
        mainButton.removeAttribute('aria-disabled');
      }

      const disabled = selectingSize ? false : (mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true');
      if (stickyButton.disabled !== disabled) stickyButton.disabled = disabled;
      if (label && mainLabel && label.textContent !== mainLabel) label.textContent = mainLabel;
    }
  };

  const initialize = (bar) => {
    if (roots.has(bar)) return;
    roots.add(bar);

    const productInfo = bar.closest('product-info');
    if (!productInfo) return;

    const scheduleSync = () => {
      window.requestAnimationFrame(() => sync(bar));
      window.setTimeout(() => sync(bar), 350);
    };

    bar.addEventListener('click', (event) => {
      const stickyButton = event.target.closest('[data-sticky-submit]');
      if (!stickyButton) return;

      const mainButton = productInfo.querySelector(`#ProductSubmitButton-${CSS.escape(bar.dataset.sectionId)}`);
      const mainLabel = mainButton?.querySelector('span')?.textContent || stickyButton.querySelector('[data-sticky-label]')?.textContent;
      if (isSelectSizeLabel(mainLabel)) {
        event.preventDefault();
        scrollToSizeSelector(productInfo);
        return;
      }

      if (!mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        scrollToSizeSelector(productInfo);
        return;
      }
      mainButton.click();
    });

    productInfo.addEventListener('click', (event) => {
      const mainButton = event.target.closest(`#ProductSubmitButton-${CSS.escape(bar.dataset.sectionId)}`);
      if (!mainButton || !isSelectSizeLabel(mainButton.querySelector('span')?.textContent)) return;

      event.preventDefault();
      event.stopPropagation();
      scrollToSizeSelector(productInfo);
    });

    productInfo.addEventListener('change', scheduleSync);
    const observer = new MutationObserver(scheduleSync);
    observer.observe(productInfo, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'checked'] });
    sync(bar);
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-lusso-sticky-cart]').forEach(initialize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
